/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { selectCustomer } from '../selectors';

import { setCustomer } from './actions';
import { thunkSetCustomerName as supervisorsSetCustomerName } from '../../Supervisors/actions';
import { thunkSetCustomerName as managersSetCustomerName } from '../../ProjectManagers/actions';
import { thunkSetCustomerName as techniciansSetCustomerName } from '../../Technicians/actions';


const thunkSetCustomerName = customerName => (dispatch, getState) => {
  const currentCustomerName = selectCustomer(getState())
  if (customerName !== currentCustomerName) {
    dispatch(setCustomer(customerName));
    dispatch(supervisorsSetCustomerName(customerName));
    dispatch(managersSetCustomerName(customerName));
    dispatch(techniciansSetCustomerName(customerName));
  }
};

export { thunkSetCustomerName };
